import {
  colors, fontSizes, sizes, zIndex,
} from '~/assets/styles/variables'

const {
  white, textBlack, blue, backgroundGray,
} = colors

export const theme = {
  palette: {
    primary: {
      main: blue,
      contrastText: white,
    },
    text: {
      primary: textBlack,
    },
    background: {
      default: white,
    },
    gray: {
      50: backgroundGray,
    },
  },
  fontSizes,
  sizes,
  zIndex,
}
